/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getBooleanDecoder,
  getBooleanEncoder,
  getI64Decoder,
  getI64Encoder,
  getStructDecoder,
  getStructEncoder,
  getU16Decoder,
  getU16Encoder,
  getU64Decoder,
  getU64Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Event emitted when protocol config is updated */
export type ProtocolConfigUpdatedEvent = {
  authority: Address;
  feesEnabled: boolean;
  escrowFeeBps: number;
  agentRegistrationFee: bigint;
  listingFee: bigint;
  disputeFeeBps: number;
  timestamp: bigint;
};

export type ProtocolConfigUpdatedEventArgs = {
  authority: Address;
  feesEnabled: boolean;
  escrowFeeBps: number;
  agentRegistrationFee: number | bigint;
  listingFee: number | bigint;
  disputeFeeBps: number;
  timestamp: number | bigint;
};

export function getProtocolConfigUpdatedEventEncoder(): FixedSizeEncoder<ProtocolConfigUpdatedEventArgs> {
  return getStructEncoder([
    ["authority", getAddressEncoder()],
    ["feesEnabled", getBooleanEncoder()],
    ["escrowFeeBps", getU16Encoder()],
    ["agentRegistrationFee", getU64Encoder()],
    ["listingFee", getU64Encoder()],
    ["disputeFeeBps", getU16Encoder()],
    ["timestamp", getI64Encoder()],
  ]);
}

export function getProtocolConfigUpdatedEventDecoder(): FixedSizeDecoder<ProtocolConfigUpdatedEvent> {
  return getStructDecoder([
    ["authority", getAddressDecoder()],
    ["feesEnabled", getBooleanDecoder()],
    ["escrowFeeBps", getU16Decoder()],
    ["agentRegistrationFee", getU64Decoder()],
    ["listingFee", getU64Decoder()],
    ["disputeFeeBps", getU16Decoder()],
    ["timestamp", getI64Decoder()],
  ]);
}

export function getProtocolConfigUpdatedEventCodec(): FixedSizeCodec<
  ProtocolConfigUpdatedEventArgs,
  ProtocolConfigUpdatedEvent
> {
  return combineCodec(
    getProtocolConfigUpdatedEventEncoder(),
    getProtocolConfigUpdatedEventDecoder(),
  );
}
